/* global Alpine */
document.addEventListener('alpine:init', () => {
  Alpine.data('storyFilter', () => ({
    industryFilters: [],
    sizeFilters: [],
    visibleCount: 0,
    batchSize: 6,

    get cards() {
      return Array.from(document.querySelectorAll('.story-card'));
    },

    get filteredCards() {
      return this.cards.filter((card) => {
        const industry = card.dataset.industry;
        const size = card.dataset.size;

        const matchesIndustry =
          this.industryFilters.length === 0 || this.industryFilters.includes(industry);

        const matchesSize =
          this.sizeFilters.length === 0 || this.sizeFilters.includes(size);

        return matchesIndustry && matchesSize;
      });
    },

    updateVisibleCount() {
      this.visibleCount = Math.min(this.visibleCount + this.batchSize, this.filteredCards.length);
    },

    clearFilters() {
      this.industryFilters = [];
      this.sizeFilters = [];
      this.visibleCount = this.batchSize;
    },

    toggleFilter(type, value) {
      const filterArr = type === 'industry' ? this.industryFilters : this.sizeFilters;
      const idx = filterArr.indexOf(value);
      if (idx === -1) {
        filterArr.push(value);
      } else {
        filterArr.splice(idx, 1);
      }
      this.visibleCount = this.batchSize;
    },

    init() {
      this.visibleCount = this.batchSize;
    }
  }));
});